import React from "react";
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  IconButton,
  useTheme,
  useMediaQuery,
  CircularProgress,
  Chip,
} from "@mui/material";
import { Close, Person } from "@mui/icons-material";
import DaySummaryCards from "./DaySummaryCards";
import ShiftInformation from "./ShiftInformation";
import OrdersBreakdown from "./OrdersBreakdown";
import RoutesCoverage from "./RoutesCoverage";

const DetailModal = ({ day, onClose, loading, open, driverName }) => {
  console.log("day test",day)
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  if (!day) return null;

  // Handle rest days
  if (day.status === "rest") {
    return (
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={onClose}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          sx={{
            bgcolor: "#f5f5f5",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box>
            <Typography variant="h6" fontWeight="bold">
              {new Date(day.date).toLocaleDateString("en-US", {
                weekday: "long",
                year: "numeric",
                month: "long",
                day: "numeric",
              })}
            </Typography>
            <Box
              sx={{ display: "flex", alignItems: "center", gap: 1, mt: 0.5 }}
            >
              <Typography variant="body2" color="textSecondary">
                No deliveries
              </Typography>
              {driverName && (
                <Chip
                  icon={<Person />}
                  label={driverName}
                  variant="outlined"
                  size="small"
                  sx={{
                    height: "20px",
                    fontSize: "11px",
                    "& .MuiChip-icon": {
                      fontSize: "14px",
                    },
                  }}
                />
              )}
            </Box>
          </Box>
          <IconButton onClick={onClose}>
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Box p={3} textAlign="center">
            <Typography variant="h5" color="primary" gutterBottom>
              No deliveries
            </Typography>
            <Typography variant="body1" color="textSecondary">
              No deliveries scheduled for this day
            </Typography>
          </Box>
        </DialogContent>
      </Dialog>
    );
  }

  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        style: {
          height: "90vh",
          maxHeight: "90vh",
        },
      }}
    >
      <DialogTitle
        sx={{
          bgcolor: "#f5f5f5",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box>
          <Typography variant="h6" fontWeight="bold">
            {new Date(day.date).toLocaleDateString("en-US", {
              weekday: "long",
              year: "numeric",
              month: "long",
              day: "numeric",
            })}
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 0.5 }}>
            <Typography variant="body2" color="textSecondary">
              Delivery Report
            </Typography>
            {driverName && (
              <Chip
                icon={<Person />}
                label={`${driverName}`}
                variant="outlined"
                size="small"
                sx={{
                  height: "20px",
                  fontSize: "11px",
                  "& .MuiChip-icon": {
                    fontSize: "14px",
                  },
                }}
              />
            )}
          </Box>
        </Box>
        <IconButton onClick={onClose}>
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ p: 0, height: "100%" }}>
        {loading ? (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="400px"
          >
            <CircularProgress />
          </Box>
        ) : (
          <Box p={3} height="100%" overflow="auto">
            {/* Summary Cards */}
            <DaySummaryCards day={day} />

            {/* Shift Information */}
            <ShiftInformation shift={day.shift} />

            {/* Orders Breakdown */}
            {day.shift === "AM/PM" && (
              <OrdersBreakdown
                amOrders={day.amOrders}
                pmOrders={day.pmOrders}
              />
            )}

            {/* Routes Coverage */}
            <RoutesCoverage deliveryRoutes={day.delivery_routes} />
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default DetailModal;
